// relative
import { apiSlice } from '../../apiSlice';

export const eforsyningIntegrationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createEforsyningIntegration: builder.mutation({
      query: (payload) => ({
        url: '/EforsyningIntegrations',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['EforsyningIntegrations'],
    }),
    getEforsyningIntegrationsByAccount: builder.query({
      query: (accountId) => ({
        url: `/EforsyningIntegrations?Account.AccountId=eq(${accountId})&top=1000`,
      }),
      providesTags: ['EforsyningIntegrations'],
    }),
    getEforsyningIntegrationById: builder.query({
      query: (integrationId) => ({
        url: `/EforsyningIntegrations/${integrationId}`,
      }),
      providesTags: ['EforsyningIntegrations'],
    }),
    updateEforsyningIntegration: builder.mutation({
      query: ({ integrationId, payload }) => ({
        url: `/EforsyningIntegrations/${integrationId}`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['EforsyningIntegrations'],
    }),
    deleteEforsyningIntegration: builder.mutation({
      query: (integrationId) => ({
        url: `/EforsyningIntegrations/${integrationId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EforsyningIntegrations'],
    }),
  }),
});

export const {
  useCreateEforsyningIntegrationMutation,
  useGetEforsyningIntegrationsByAccountQuery,
  useGetEforsyningIntegrationByIdQuery,
  useUpdateEforsyningIntegrationMutation,
  useDeleteEforsyningIntegrationMutation,
} = eforsyningIntegrationsApiSlice;
